
export default class Banner {

	static getHolderSelectors = () => ['.banner-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		const video = this.#holderElement.querySelector('video');

		if (video && Hls.isSupported()) {
			const hls = new Hls();
			hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
				hls.startLevel = -1;
			});
			hls.loadSource(video.dataset.videoUrl);
			hls.attachMedia(video);
		} else if (video && video.canPlayType('application/vnd.apple.mpegurl')) {
			video.src = video.dataset.videoUrl;
			video.addEventListener('loadedmetadata', () => video.play());
		} else if (video) {
			console.warn('HLS is not supported for this browser');
		}
	}

}
